import React, { useState } from "react";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../firebase";
import {
  TextField,
  Button,
  Box,
  Grid,
  Container,
  IconButton,
  Typography,
  Card,
  CardContent,
  Snackbar,
  Alert,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DynamicUploadModal from "../../../components/UploadModal";
import SpecialitiesSelector from "../../../components/topicCategorySelector/SpecialitiesSelector";

const AddCategory = () => {
  const [openModal, setOpenModal] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [category, setCategory] = useState({
    description: "",
    id: "",
    imageUrl: "",
    router_to: "",
    title: "",
    specialist: "",
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);

  // Open/close upload modal
  const handleModalClose = () => setOpenModal(false);

  // Handle upload success
  const handleUploadSuccess = (url) => {
    setUploadedImageUrl(url);
    setCategory((prev) => ({ ...prev, imageUrl: url }));
  };

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Specialities Selector
  const handleSelectSpecialities = (selectedSpeciality) => {
    setCategory((prev) => ({
      ...prev,
      specialist: selectedSpeciality.name,
      router_to: selectedSpeciality.id,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const uniqueId = uuidv4();
    const categoryData = {
      ...category,
      id: uniqueId,
      timestamp: serverTimestamp(),
    };

    try {
      await setDoc(doc(db, "categories", uniqueId), categoryData);
      setOpenSnackbar(true);
      setCategory({
        description: "",
        id: "",
        imageUrl: "",
        router_to: "",
        title: "",
        specialist: "",
      });
      setUploadedImageUrl("");
    } catch (error) {
      console.error("Error adding category: ", error);
      alert("Error adding category");
    }
  };

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card>
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom>
            Add New Category
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Title"
                  name="title"
                  value={category.title}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  value={category.description}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="ID (Auto-generated)"
                  name="id"
                  value={category.id || "Auto-generated"}
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Image URL"
                  name="imageUrl"
                  value={uploadedImageUrl}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12}>
                <IconButton
                  onClick={() => setOpenModal(true)}
                  color="primary"
                  aria-label="upload image"
                >
                  <PhotoCamera />
                </IconButton>
              </Grid>
              <Grid item xs={12}>
                <SpecialitiesSelector onSelectSpecialities={handleSelectSpecialities} />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Specialist"
                  name="router_to"
                  value={category.router_to}
                  InputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                >
                  Add Category
                </Button>
              </Grid>
            </Grid>
          </form>

          <DynamicUploadModal
            open={openModal}
            onClose={handleModalClose}
            uploadPreset="bookMyDr"
            folderName="Madecare"
            maxSize={5 * 1024 * 1024}
            onUploadSuccess={handleUploadSuccess}
          />
        </CardContent>
      </Card>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          Category added successfully!
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AddCategory;
